// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {Fragment, useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {use_download} from '../shared/use_download';
import {Svg_img} from '../ui/svg_img';
import {img_url} from '../ui/img_url';
import styles from './game_boost_hero.module.less';
import user_agent from '/util/user_agent.js';
import cn from 'classnames';

const is_win = user_agent.guess().os=='windows';

const default_badges = ['Free', 'No Login Required',
    'Works with Popular Games'];

interface i_game_boost_hero_props {
    title: string;
    subtitle: string;
    button_text: string;
    download_type?: string;
    badges?: string[];
}

export const Game_boost_hero = (props: i_game_boost_hero_props)=>{
    const {title, subtitle, button_text,
        download_type = 'gameboost', badges = default_badges} = props;
    const {theme} = useContext(Settings_context);
    const {screen} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const {download, download_gameboost} = use_download();
    const on_download = ()=>{
        if (download_type=='gameboost')
            return void download_gameboost();
        download();
    };
    const _title = is_win ? title
        : 'Kill Lag Instantly. For Free.';
    return <div className={styles.hero}>
      <div className={styles.hero_text}>
        <h1 className={styles.page_header}>{_title}</h1>
        <p className={theme.u2}>{subtitle}</p>
        <div className={styles.badges}>
          {badges.map((b, i)=>
            <div key={i} className={styles.badge}>
              <Svg_img id={'hola2023/icons/18/check_gray.svg'} w={16}
                h={16} />
              <p className={cn([theme.p4, theme.med, theme.color_n600,
                styles.badge_text])}>{b}</p>
            </div>
          )}
        </div>
        <Button on_click={on_download} caption={button_text}
          color="black2023"
          size={is_mobile ? 'md' : 'lg'}
          round />
      </div>
      <div className={styles.hero_img}>
        <img src={img_url('hola2023/game_boost.svg')} alt="" />
      </div>
    </div>;
};

interface i_game_boost_hero_editor_props {
    value: i_game_boost_hero_props;
    on_change: (new_val: i_game_boost_hero_props)=>void;
}

export const Game_boost_hero_editor = (
{value, on_change}: i_game_boost_hero_editor_props)=>{
    const badges = value.badges || default_badges;
    const set_badges = (next: string[])=>
        on_change({...value, badges: next});
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h1)', type: 'text'},
        {key: 'subtitle', label: 'Subtitle', type: 'text'},
        {key: 'button_text', label: 'Button text', type: 'text'},
        {key: 'download_type', label: 'Download type (gameboost / vpn)',
          type: 'text'},
      ]}>
      <Fragment>
        <h4>Badges</h4>
        {badges.map((badge, i)=><Editor<{text: string}> key={i}
          value={{text: badge}}
          editors={[{key: 'text', label: `Badge ${i+1}`, type: 'text'}]}
          on_change={v=>set_badges(badges.map((b, j)=>
            j==i ? v.text : b))}
          on_remove={()=>set_badges(badges.filter((_, j)=>j!=i))} />
        )}
        <Button caption="Add badge" size="xs"
          on_click={()=>set_badges([...badges, 'New badge'])} />
      </Fragment>
    </Editor>;
};
